import React from "react";
import Icon from "@/ui/Icon";
import { Spinner } from "@/ui/Spinner";
import { truncateText, formatNumber } from "@/lib/utils";
import { CurrentUserProfile } from "@thrivecoin/adapter/dist/types";
import UserMenu from "./UserMenu/UserMenu";
import NotificationManager from "@/components/Notifications";
import EcosystemSelector from "./EcosystemSelector";

interface UserInfoBarProps {
  user: { username: string; address: string };
  currentUser?: CurrentUserProfile;
  isLoading: boolean;
  logout: () => void;
}

const UserInfoBar: React.FC<UserInfoBarProps> = ({ user, currentUser, isLoading, logout }) => {
  return (
    <div className="flex flex-row flex-wrap items-center justify-center gap-3 text-white md:flex-row md:flex-nowrap">
      <EcosystemSelector />
      <div className="inline-flex h-10 items-center justify-center gap-2 rounded-[100px] bg-[#191B20] px-4 py-2">
        <Icon name="thrive" size={16} />
        {isLoading ? (
          <Spinner size={16} />
        ) : (
          <div className="text-Light-Gray whitespace-nowrap text-sm font-normal leading-tight opacity-80">
            {formatNumber(currentUser?.all_time_earnings ?? 0)} Points
          </div>
        )}
      </div>

      <div className="inline-flex h-10 items-center justify-center gap-2 rounded-[100px] bg-[#191B20] px-4 py-2">
        <div className="text-sm font-normal leading-tight text-[#B8B8B8] opacity-80">
          {truncateText(currentUser?.username ?? user.username)}
        </div>
      </div>

      <NotificationManager />

      <UserMenu logout={logout} image={currentUser?.image_url} />
    </div>
  );
};
export default UserInfoBar;
